/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { ReactElement } from "react";
import { strings } from "../../../common/Strings/Strings";

interface Props {
  title: string;
  message: string;
  actionButton?: string;
  path: string;
}

export default function EmailNotificationPreview(props: Props): ReactElement {
  const { title, message, actionButton, path } = props;

  return (
    <div style={{ backgroundColor: "#F5F6F6", padding: "10px", display: "flex", justifyContent: "center" }}>
      <table
        style={{
          borderSpacing: 0,
          padding: 0,
          borderRadius: "10px",
          backgroundColor: "#ffffff",
          fontFamily: "'Nunito Sans', Arial, sans-serif",
          color: "#2E2E2F",
          fontSize: "16px",
          lineHeight: "150%",
          width: "90%",
          boxSizing: "border-box",
        }}
      >
        <tbody>
          <tr>
            <td
              width="100%"
              style={{
                padding: "25px",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                backgroundColor: "#465364",
                color: "#ffffff",
              }}
            >
              <h1 style={{ fontSize: "18px", lineHeight: "20px", fontWeight: 600 }}>{title}</h1>
            </td>
          </tr>
          <tr>
            <td width="100%" style={{ padding: "25px" }}>
              <p
                style={{ color: "#2E2E2F", whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{ __html: message || strings.emailNotificationMessage }}
              />
            </td>
          </tr>

          {actionButton && (
            <tr>
              <td width="100%" style={{ paddingTop: "30px", paddingBottom: "30px" }}>
                <center>
                  <a
                    href={path}
                    style={{
                      padding: "10px 25px",
                      borderRadius: "4px",
                      backgroundColor: "#0CA2FE",
                      color: "#ffffff",
                      fontWeight: 600,
                      cursor: "pointer",
                      display: "inline-block",
                      textAlign: "center",
                    }}
                  >
                    {actionButton}
                  </a>
                </center>
              </td>
            </tr>
          )}

          <tr>
            <td width="100%" style={{ padding: "5px 25px" }}></td>
          </tr>

          <tr>
            <td
              style={{
                backgroundColor: "transparent",
                padding: "20px 25px",
              }}
              valign="top"
            >
              <table
                align="center"
                border={0}
                cellPadding="0"
                cellSpacing="0"
                width="100%"
                style={{ backgroundColor: "transparent", width: "100%" }}
                role="presentation"
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        minWidth: "100%",
                        borderTop: "1px solid #d6d6d6",
                        lineHeight: 0,
                        fontSize: 0,
                      }}
                      valign="top"
                    >
                      &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ padding: "5px 25px", textAlign: "center" }}>
              <div className="flex justify-center items-center space-x-2">
                <a
                  href="https://www.facebook.com/globalvethu/"
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    width="24"
                    height="24"
                    alt="Facebook icon"
                    src="https://cdn-images.mailchimp.com/icons/social-block-v3/block-icons-v3/facebook-outline-dark-40.png"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/globalvet-practice-management-software/"
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    width="24"
                    height="24"
                    alt="LinkedIn icon"
                    src="https://cdn-images.mailchimp.com/icons/social-block-v3/block-icons-v3/linkedin-outline-dark-40.png"
                  />
                </a>
              </div>
            </td>
          </tr>

          <tr>
            <td style={{ padding: "5px 25px", textAlign: "center" }}>
              <div className="flex justify-center items-center space-x-2">
                <a href="https://globalvet.com" target="_blank" rel="noreferrer">
                  <img
                    width="169.2"
                    alt="GlobalVET logo"
                    src="https://mcusercontent.com/3f4fefa9a771c3802ae4b3b32/images/05433848-d32c-148f-3e82-2cbf3ff11564.png"
                    role="presentation"
                  />
                </a>
              </div>
            </td>
          </tr>

          <tr>
            <td style={{ padding: "5px 25px", textAlign: "center" }}>
              <p>
                <em>
                  <span style={{ fontSize: "12px" }}>Copyright (C) 2025 GlobalVET. All rights reserved.</span>
                </em>
                <br />
                <br />
                <span style={{ fontSize: "12px" }}>Our mailing address:</span>
                <br />
                <span style={{ fontSize: "12px" }}>GlobalVET Bruksvägen 26-33 374 91 ASARUM 37230 Sweden</span>
                <br />
                <br />
                <span style={{ fontSize: "12px" }}>This is an automated message from GlobalVET.</span>
                <br />
                <span style={{ fontSize: "12px" }}>For further assistance, please contact</span>
                <a style={{ color: "#0ca2fe", fontSize: "12px" }} href="mailto:support@globalvet.com">
                  {" "}
                  support@globalvet.com
                </a>
                .
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
